import { Component, ViewEncapsulation, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { AppState } from '../../../app/app.service';
import { AuthService } from '../../../app/auth/auth.service';
import { Subscription } from 'rxjs/Rx';
import { TroubleshootingService } from './troubleshooting.service';
import { VcaAlertsService } from '../../../common/vca-alerts';
import { HttpUtils } from '../../../common/http/http-utils';
import { AlarmsNotifierService } from '../../../app/services/alarm-notifier.service';
import { ClientUtilities } from './utils/client-utils';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'environments/environment';
const _ = require('lodash');
const $ = require('jquery');

@Component({
  selector: 'app',
  encapsulation: ViewEncapsulation.None,
  styles: [require('./troubleshooting.scss')],
  templateUrl: './troubleshooting.html',
})

export class TroubleShootingApp {
    private alarmData: any;
    private loadedAlarm: boolean = false;
    private loadedHcm: boolean = false;

    private getHandler: Subscription;
    private getTechSupportHandler: Subscription;
    private getGenerateHandler: Subscription;
    private getHandlerFleetJob: Subscription;
    private getHcmHandler: Subscription;

    private closedAlarms: any = {};

    private subscription: Subscription;
    private showConfirm: boolean = false;
    private actionInProgress: boolean = false;
    private dlActionInProgress: boolean = false;
    private confirmTitle: string;
    private confirmMsg: string;
    private confirmData: any = {};

    private techlogFleetExist: boolean = false;
    private techlogFleet: any;
    private techSupportBundleModel: any = {};
    private techlogModalFormValid: boolean = false;
    private loadedFleet: boolean = false;

    private fleetComponentJob: any;
    private generateTechSupportJob: any;
    private fleetComponentData: any;
    private techSupportData: any;
    private techSupportBundleJobError: any = null;
    private loadedTechSupport: boolean = false;
    private hcmData: any;

    private setIntervalLogs: any;
    private isVsphereClient: boolean = false;
    private resourceNamePrefix: string = '';

    private alarmPollerSubscription: Subscription;
    private setTechSupportIntervalLogs: any;

    private isTechSupportSettingsLoaded: boolean = false;
    private isAutoApproved: boolean = false;
    private isAutoApproveModalVisible: boolean = false;
    isHCXWithoutCnC: boolean = false;

    preparingDownload = false;

    constructor(private alarmsNotifierService: AlarmsNotifierService, private troubleshootingService: TroubleshootingService,
                private translateService: TranslateService,
                public appState: AppState, private alert: VcaAlertsService, public authService: AuthService) {
        const path = (window.location.pathname.match(/(.*)(\/troubleshooting-ui)(\/.*|$)/) || [])[1];
        this.isVsphereClient = !!path && ClientUtilities.runningInPluginUI();

        const currentLocation = document.location.toString();
        var hcxLicenseData = JSON.parse(sessionStorage.getItem('hcx-license-data'));
        this.isHCXWithoutCnC =  hcxLicenseData.data 
                                && hcxLicenseData.data.activationType 
                                && ['STANDALONE_CONNECTED', 'STANDALONE_DISCONNECTED'].indexOf(hcxLicenseData.data.activationType.toUpperCase()) > -1

        if (!!this.isVsphereClient) {
            this.troubleshootingService.loadHcmData();
        } else {
            this.loadAlarmFleetData();
        }
        if ( this.isVsphereClient ) { // ngc plugin
            this.resourceNamePrefix = 'Appliances deployed for remote site: ';
        } else {  // GVR
            this.resourceNamePrefix = 'Appliances deployed on : ';
        }
        this.initPreviousState( this.troubleshootingService.getTechSupportRunningState() );
    }

    public ngOnInit() {
        const me = this;
        this.getHcmHandler = this.troubleshootingService.hcmData
            .subscribe(
                (data) => {
                    this.hcmData = data;
                    this.loadedHcm = true;
                    this.hcmData['servers'] = [];
                    !!this.hcmData && !!this.hcmData.data && !!this.hcmData.data.localEndpoints &&
                        this.hcmData.data.localEndpoints.forEach((reference) => {
                        if (reference.hcsp && reference.hcsp.serverAddress) {
                            this.hcmData.servers.push({serverGuid: reference.resourceId, serverName: reference.resourceName});
                        }
                    });

                    if ( this.hcmData.servers && this.hcmData.servers.length > 0 ) {
                        this.hcmData.serverGuid = (this.hcmData.servers[0] && this.hcmData.servers[0].serverGuid) ?
                            this.hcmData.servers[0].serverGuid : null;
                    }

                    const roles = (this.authService.loggedInUserInfo && this.authService.loggedInUserInfo.roles) ?
                        this.authService.loggedInUserInfo.roles : [];
                    if (this.authService.isVCDGVRDepricated && _.includes(roles, 'System Administrator')) {
                        // If roles contains 'System Administrator' call support settings and alarm fleet without any checks.
                        this.loadAlarmFleetData();
                        this.loadTechSUpportSettings();
                    } else {
                        if (this.hcmData && this.hcmData.serverGuid) {
                            this.loadAlarmFleetData();
                            this.loadTechSUpportSettings();
                        } else {
                            this.loadedFleet = true;
                            this.alert.danger(['Operation Failed (server information Missing!). Please try again'], 'dl-error-location');
                        }
                    }
                }
        );
        this.getHandlerFleetJob = this.troubleshootingService.fleetComponentJob
            .subscribe(
                (fleets) => {
                    me.fleetComponentJob = fleets;
                    if ( fleets ) {
                        this.fleetComponentData = fleets;
                        this.setFleetApplianceComponents(fleets);
                    }
                }
        );
        this.getGenerateHandler = this.troubleshootingService.generateTechSupportJob
            .subscribe(
                (job) => {
                    me.generateTechSupportJob = job;
                    if ( job && job['jobId'] ) {
                        me.getTechSupportData ( job['jobId'] );
                    } else { // todo need to remove
                        this.alert.danger(['Collect support log bundle operation is failed.'], 'dl-error-location');
                        this.dlActionInProgress = false;
                    }
                }
        );
        this.getTechSupportHandler = this.troubleshootingService.techSupportData
            .subscribe(
                (data) => {
                    this.techSupportData = data;
                    this.setTechSupportData(data);
                }
        );
        if (!this.isVsphereClient) {
            this.loadTechSUpportSettings();
        }
    }

    public loadTechSUpportSettings() {
        this.troubleshootingService.getTechsupportSettings(this.isVsphereClient,
            this.hcmData && this.hcmData.serverGuid ? this.hcmData.serverGuid : null).subscribe(
            (data:any) => {
                this.isAutoApproved = data.autoAcknowledge;
                this.isTechSupportSettingsLoaded = true;
            },
            (error) => {
                this.alert.danger(['Unable to load settings'], 'techsupport-setting-error-location');
            },
            () => {}
        );
    }

    public loadAlarmFleetData() {
        this.troubleshootingService.loadFleetComponentJob(this.isVsphereClient, this.hcmData && this.hcmData.serverGuid ?
            this.hcmData.serverGuid : null);
    }

    public reset() {
        if (this.getHandlerFleetJob) { this.getHandlerFleetJob.unsubscribe(); }
        if (this.getGenerateHandler) { this.getGenerateHandler.unsubscribe(); }
        if (this.getHcmHandler) { this.getHcmHandler.unsubscribe(); }
        if (this.getTechSupportHandler) { this.getTechSupportHandler.unsubscribe(); }

        this.loadedAlarm = false;
        this.loadedHcm = false;
        this.loadedFleet = false;
        this.loadedTechSupport = false;
        this.alarmData   = [];
        this.techSupportData = [];
        this.techlogFleet = [];
        this.techlogFleetExist = false;
        this.techlogModalFormValid = false;
        this.actionInProgress = false;
        this.dlActionInProgress = false;
        this.techSupportBundleModel = {};
        this.techSupportBundleJobError = null;
        this.isTechSupportSettingsLoaded = false;
        if (this.setIntervalLogs) { clearInterval(this.setIntervalLogs); }
        if (this.setTechSupportIntervalLogs) { clearInterval(this.setTechSupportIntervalLogs); }
    }

    public initPreviousState( techSupportRunningData ) {
        if ( techSupportRunningData.jobId ) {
            this.techSupportBundleModel = techSupportRunningData.dataModel ? techSupportRunningData.dataModel : {};
            this.getTechSupportData(techSupportRunningData.jobId);
            this.dlActionInProgress = true;
            this.techlogModalFormValid = (this.techSupportBundleModel && Object.keys(this.techSupportBundleModel).length > 0 ) ? true : false;
        }
    }

    public ngOnDestroy() {
        this.reset();
    }
    private showAlarmCheck(alarm) {
        if ( alarm && this.closedAlarms && this.closedAlarms[alarm.jobId] === true ) {
            return false;
        } else {
            if (alarm.jobId) {return true; }
        }
        return false;
    }
    public askConfirmation(alarm: any, approved: boolean) { // todo
            if (alarm && approved === true) {
                this.confirmTitle = 'Approve Tech Support Bundle Request';
                this.confirmMsg = `Are you sure you want to approve the request for tech support log bundles.` ;
            } else if (alarm) {
                this.confirmTitle = 'Decline Tech Support Bundle Request';
                this.confirmMsg = `Are you sure you want to decline the request for tech support log bundles.` ;
            }
            this.confirmData['alarm'] = alarm;
            this.confirmData['approved'] = approved;
            this.showConfirm = true;
    }
    private ackAlarm() { // todo
        const me = this;
        const alarm = (this.confirmData && this.confirmData.alarm) ? this.confirmData.alarm : {};
        const approved = (this.confirmData && this.confirmData.approved) ? this.confirmData.approved : false;
        if ( alarm && alarm.jobId) {
            this.actionInProgress = true;
            const payload = {jobId: alarm.jobId, hasApproved : (approved ? true : false)};
            this.subscription = this.troubleshootingService.acknowledgeAlarm(payload, this.isVsphereClient, this.hcmData && this.hcmData.serverGuid ? this.hcmData.serverGuid : null).subscribe(
            (res) => {
                me.closedAlarms[alarm.jobId] = true;
                me.logOperationCompleted('AckAlarm operation success');
            },
            (error) => {
                me.closedAlarms[alarm.jobId] = true;
                me.logOperationCompleted('AckAlarm operation failed');
            },
            () => {
                me.closedAlarms[alarm.jobId] = true;
                me.logOperationCompleted('AckAlarm completed');
            }
            );
        }
    }
    public getTechSupportData(jobId: string) {
        const me = this;
        const techSupportRunningData: any = {};
        this.setTechSupportIntervalLogs = setInterval(function() { me.troubleshootingService.loadTechSupportData(jobId, me.isVsphereClient, me.hcmData && me.hcmData.serverGuid ? me.hcmData.serverGuid : null); }, 3000 );
        me.troubleshootingService.loadTechSupportData(jobId, this.isVsphereClient, this.hcmData && this.hcmData.serverGuid ? this.hcmData.serverGuid : null);
        techSupportRunningData.dataModel = this.techSupportBundleModel; // set current data model to service obj
        techSupportRunningData.jobId = jobId; // set current jobId to service obj
        me.troubleshootingService.setTechSupportRunningState(techSupportRunningData);
    }
    public setFleetApplianceComponents(fleets: any) {
        if ( this.fleetComponentData ) {
            if (this.setIntervalLogs) { clearInterval(this.setIntervalLogs); }
            this.techlogFleet = this.fleetComponentData ?  this.fleetComponentData : [];
            this.techlogFleetExist =  (this.techlogFleet && this.techlogFleet.length > 0)  ? true : false;
            if ( !this.techlogFleetExist ) { // If no fleets
                this.techSupportBundleModel = {collectNspTechBundle: true};
                this.techlogModalFormValid = true;
            }
            this.loadedFleet = true;
        } else {
            this.loadedFleet = false;
        }
    }
    public setFleetModalChange(elem: any, checked: any, resource: any) {
        if ( this.techSupportBundleModel[elem] ) {
            this.techlogModalFormValid = true;
        } else {
            delete(this.techSupportBundleModel[elem]);
        }
        if ( elem === 'collectLogsAppliances') {
            this.setCheckAllFleetSelected(this.techSupportBundleModel[elem] ? true : false);
        }
        if ( this.techSupportBundleModel &&
                this.techSupportBundleModel.collectLogsAppliances &&
                    this.techSupportBundleModel.collectLogsAppliances === true &&
                        Object.keys(this.techSupportBundleModel).length === 1  ) {
            delete(this.techSupportBundleModel['collectLogsAppliances']);
        }
        this.techlogModalFormValid = (this.techSupportBundleModel && Object.keys(this.techSupportBundleModel).length > 0 ) ? true : false;
    }

    public setCheckAllFleetSelected(checked) {
        if ( this.techlogFleet ) {
            this.techlogFleet.forEach((item) => {
                if ( item && item.appliances ) {
                    item.appliances.forEach( (appliance) => {
                        if ( appliance && appliance.applianceId && appliance.isAvailableForLogCollection) {
                            if (checked) {
                                this.techSupportBundleModel[appliance.applianceId] = checked;
                            } else {
                                delete(this.techSupportBundleModel[appliance.applianceId]);
                            }
                        }
                    });
                }
            });
        }
    }

    public setVcModalChange(serverGuid: any) {
        this.hcmData.serverGuid = serverGuid ? serverGuid : null;
        if ( this.hcmData && this.hcmData.serverGuid ) {
            this.loadedFleet = false;
            this.loadedTechSupport = false;
            this.techSupportData = [];
            this.techlogFleet = [];
            this.techlogFleetExist = false;
            this.techlogModalFormValid = false;
            this.actionInProgress = false;
            this.dlActionInProgress = false;
            this.techSupportBundleModel = {};
            this.techSupportBundleJobError = null;
            if (this.setIntervalLogs) { clearInterval(this.setIntervalLogs); }
            if (this.setTechSupportIntervalLogs) { clearInterval(this.setTechSupportIntervalLogs); }
            this.loadAlarmFleetData();
            this.loadTechSUpportSettings();
        }
    }

    getRequestTechSupportPayload() {
        var techSupportPayload: any = {};
        var applianceArr = [];
        if (this.techSupportBundleModel && Object.keys(this.techSupportBundleModel).length > 0) {
            // Selected Applicance and Fleets
            $.each(this.techSupportBundleModel, function(fl, val) {
                if (fl !== "collectNspTechBundle" && fl !== "collectLogsAppliances" && fl !== "collectMongoDump") {
                    applianceArr.push(fl);
                }
            });
            techSupportPayload["collectNspTechBundle"] = this.techSupportBundleModel.collectNspTechBundle ? true : false;
            techSupportPayload["collectMongoDump"] = this.techSupportBundleModel.collectMongoDump ? true : false;
            techSupportPayload["fleetAppliances"] = applianceArr;
        }
        return techSupportPayload;
    }
    public generateTechSupportLog() {
        this.dlActionInProgress = true;
        this.troubleshootingService.requestLogBundle(this.getRequestTechSupportPayload(), this.isVsphereClient, this.hcmData && this.hcmData.serverGuid ? this.hcmData.serverGuid : null);
    }
    public setTechSupportData(data: any) {
        if ( this.techSupportData && ( this.techSupportData.state === 'COMPLETE' || this.techSupportData.state === 'SUCCESS' || this.techSupportData.state === 'PARTIAL_SUCCESS' || this.techSupportData.state === 'FAILED' ) ) {
            if ( this.techSupportData.state === 'FAILED' ) {
                if ( this.techSupportData.response && this.techSupportData.response.error ) {
                    this.alert.danger([this.techSupportData.response.error], 'dl-error-location');
                } else {
                    this.alert.danger(['Operation Failed. Please try again'], 'dl-error-location'); // todo
                }
            } else if ( this.techSupportData.response && this.techSupportData.response.error &&  (this.techSupportData.state !== 'COMPLETE' || this.techSupportData.state !== 'SUCCESS') ) {
                this.alert.info([this.techSupportData.response.error], 'dl-error-location');
            } else if (this.techSupportData.response && this.techSupportData.response.failedFleetAppliances !== "") {
                try {
                    let failedFleetAppliances = JSON.parse(this.techSupportData.response.failedFleetAppliances);
                    if (failedFleetAppliances) {
                        let errMessages: string[] = [];
                        failedFleetAppliances.forEach( (err) => {
                            if (err.error) {
                                errMessages.push(`Failed to collect tech support logs for Appliance : ${err.applianceType} deployed on Resource : ${err.resourceName}. Reason : ${err.error}`);
                            }
                        });
                        this.alert.danger(errMessages, 'dl-error-location');
                    }
                } catch (ex) {
                    console.error(`Failed to parse object : ${this.techSupportData.response.failedFleetAppliances}`);
                }
            }
            if (this.setTechSupportIntervalLogs) { clearInterval(this.setTechSupportIntervalLogs); }
            this.loadedTechSupport = true;
            this.ondLActionComplete();
        } else {
            this.loadedTechSupport = false;
        }
    }
    public ondLActionComplete() {
        this.dlActionInProgress = false;
    }
    public onDownloadLogBundle(data: any) {
        if ( this.techSupportData && this.techSupportData.response && this.techSupportData.response.fileName ) {
            let dUrl = '';
            if (this.isVsphereClient) {
                const path = (window.location.pathname.match(/(.*)(\/troubleshooting-ui)(\/.*|$)/) || [])[1];
                const vsphereBaseUrl = !!path ? path + '/hcx-ui/rest' : '';

                const vcGuid = this.hcmData && this.hcmData.serverGuid ? this.hcmData.serverGuid : null;
                dUrl = HttpUtils.getSiteUrl() + vsphereBaseUrl + '/hybridity/api/techsupport/bundles?filename='   + this.techSupportData.response.fileName + '&vcGuid=' + vcGuid + '&cb=' + Date.now();
            } else if(environment.loadedInVCRemotePlugin) {
                dUrl = `${HttpUtils.getBaseUrl()}/hybridity/api/techsupport/bundles/${this.techSupportData.response.fileName}`; 
            } else {
                dUrl = HttpUtils.getSiteUrl() + '/hybridity/api/techsupport/bundles/'  + this.techSupportData.response.fileName;
            }
            let fileName = dUrl.split('/').reverse()[0] || '';
            if(fileName.indexOf('bundles?') > -1) {
                const _url = new URL(dUrl);
                fileName = _url.searchParams.get('filename');
            }
            this.preparingDownload = true;
             fetch(dUrl, {
                headers:{
                    'x-hm-authorization': environment.token ? atob(environment.token) : null
                }
            })
            .then((response) => response.blob())
            .then((blob) => {
                this.preparingDownload = false;
                var _url = window.URL.createObjectURL(blob);
                const elem = document.createElement('a');
                elem.setAttribute('display', 'none');
                elem.setAttribute('href', _url);
                elem.setAttribute('download', fileName);
                // fix for firefox browser, as firefox don't entertain click on elements not attached to DOM.
                document.querySelector('body').appendChild(elem);
                elem.click();
                elem.remove();
                // reset service obj after user downloaded
                const techSupportRunningData: any = {};
                techSupportRunningData.dataModel = {}; // set current data model to service obj
                techSupportRunningData.jobId = null; // set current jobId to service obj
                this.troubleshootingService.setTechSupportRunningState(techSupportRunningData);
            })
            .catch((err) => {
                this.preparingDownload = false;
                this.alert.danger([`Error downloading tech support bundle file requested.Reason: ${err}`], 'dl-error-location');
            });
            /* window.open(dUrl, '_blank'); // todo */
        }
    }

    public openAutoApproveModel(event) {
        event.preventDefault();
        this.isAutoApproveModalVisible = true;
    }

    public changeAutoApprove(toggle: boolean) {
        if (toggle) {
            this.troubleshootingService.updateTechsupportSettings({
                autoAcknowledge: !this.isAutoApproved
            },
            this.isVsphereClient,
            this.hcmData && this.hcmData.serverGuid ? this.hcmData.serverGuid : null).subscribe((res) => {
                    this.isAutoApproveModalVisible = false;
                    this.isAutoApproved = !this.isAutoApproved;
                },
                (error) => {
                    this.alert.danger(['Operation Failed. Please try again'], 'techsupport-setting-modal-error-location');
                },
                () => {}
            );
        } else {
            this.isAutoApproveModalVisible = false;
        }
    }
    private logOperationCompleted(msg: string) {
        this.actionInProgress = false;
        this.showConfirm = false;
    }

    public getTitleForApplianceCheckbox(appliance) {
        return appliance.isAvailableForLogCollection ? '' : this.translateService.instant('troubleShooting.applianceLogNotEligibleTooltip');
    }
}



// WEBPACK FOOTER //
// ./src/troubleshooting/src/troubleshooting-ui/troubleshooting.component.ts